export type ScoutSuggestion = {
  label: string;
  prompt: string;
};

export const SCOUT_SUGGESTIONS: ScoutSuggestion[] = [
  {
    label: "Explore Tier II thresholding in New York vs. NYC",
    prompt:
      "Can you tell me how the reporting thresholds differ between the state of New York and New York City?",
  },
  {
    label: "Review RCRA Biennial Report requirements in Texas",
    prompt:
      "Can you tell me about the RCRA Biennial Report filing requirements and deadlines for hazardous waste generators in Texas?",
  },
  {
    label: "Learn about the waste reporting schedule in Arizona",
    prompt: "Can you tell me about the RCRA waste reporting schedule in the state of Arizona?",
  },
  {
    label: "Check extra Tier II data collection requirements in Kansas",
    prompt:
      "Can you tell me about the data collection requirements for Tier II reporting in the state of Kansas?",
  },
];

export const SCOUT_SUGGESTIONS_DISPLAY_COUNT = 4;
